import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export default function ContentOverlay({ isVisible, facet }) {
    return (<div aria-hidden="true" className={ classnames('content-overlay', `content-overlay__${ facet }`, { 'content-overlay__active': isVisible })}></div>);
}

ContentOverlay.propTypes = {
    facet: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/content-overlay/index.js